import "bootstrap-icons/font/bootstrap-icons.css";
import "./validator.js";
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider, getToken } from "firebase/app-check";
import { getAuth } from "firebase/auth";
import App from "./App.vue";
import { createApp } from "vue";
import router from "./router";
import { pinia } from '@/plugins/pinia'

const app = createApp(App);

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};
const firebase = initializeApp(firebaseConfig);
export const auth = getAuth(firebase);
export const appCheck = initializeAppCheck(firebase, {
  provider: new ReCaptchaV3Provider(process.env.VUE_APP_FIREBASE_RECAPTCHA_V3_SITE_KEY),
  isTokenAutoRefreshEnabled: true,
});
export async function getAppCheckHeader() {
  try {
    const { token } = await getToken(appCheck, false);
    return token ? { "X-Firebase-AppCheck": token } : {};
  } catch {
    return {};
  }
}
app.config.globalProperties.$auth = auth;

app.use(pinia)
app.use(router);
app.mount("#app");

Array.prototype.chunk = function(size) {
  return Array.from({length: Math.ceil(this.length / size)}, (_, i) =>
    this.slice(i * size, i * size + size)
  );
};
